import { Tabs as KTabs } from '@kobalte/core/tabs'
import type { ComponentProps, JSX } from 'solid-js'

const Root = (props: ComponentProps<typeof KTabs>): JSX.Element => <KTabs {...props} class={'flex flex-col ' + (props.class ?? '')} />
const List = (props: ComponentProps<typeof KTabs.List>) => (
  <KTabs.List class={'flex gap-6 border-b border-border relative ' + (props.class ?? '')} {...props}>
    {props.children}
    <KTabs.Indicator class="absolute bottom-0 h-[2px] bg-accent transition-all duration-base" />
  </KTabs.List>
)
const Trigger = (props: ComponentProps<typeof KTabs.Trigger>) => (
  <KTabs.Trigger
    class={'py-3 text-sm font-medium text-muted data-[selected]:text-fg hover:text-fg ' + (props.class ?? '')}
    {...props}
  />
)
const Content = (props: ComponentProps<typeof KTabs.Content>) => <KTabs.Content class={'pt-6 ' + (props.class ?? '')} {...props} />

export const Tabs = Object.assign(Root, { List, Trigger, Content })
